import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";
import { toast } from "react-toastify";

const toFormDataOrderPayload = (brand, order) => {
  const body = new FormData();
  body.append("title", brand.title || "");
  body.append("slug", brand.slug || "");
  body.append("description", brand.description || "");
  body.append("order", String(order));
  const isActive =
    brand.isActive === true ||
    brand.isActive === "true" ||
    brand.isActive === 1 ||
    brand.isActive === "Active";
  body.append("isActive", isActive ? "true" : "false");
  return body;
};

export const useBrandReorder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (orderedBrands) => {
      const updates = orderedBrands.map((brand, index) => {
        const id = brand._id || brand.id;
        const body = toFormDataOrderPayload(brand, index);
        return api.put(`/brand/update/${id}`, body, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      });

      await Promise.all(updates);

      return orderedBrands.map((brand, index) => ({ ...brand, order: index }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["viewBrand"] });
    },
    onError: (error) => {
      console.error("REORDER ERROR:", error.response || error);
      toast.error(
        error.response?.data?.message || "Failed to update brand order"
      );
    },
  });
};
